import { render, staticRenderFns } from "./homeTrain.vue?vue&type=template&id=f1432e68&scoped=true&"
import script from "./homeTrain.vue?vue&type=script&lang=js&"
export * from "./homeTrain.vue?vue&type=script&lang=js&"
import style0 from "./homeTrain.vue?vue&type=style&index=0&id=f1432e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1432e68",
  null
  
)

component.options.__file = "homeTrain.vue"
export default component.exports